import { IconComponent } from 'models/icons';

/**
 * @deprecated This component has following errors from generation:
 *
 * **ERROR: assets/icons/download-assets.svg contains multiple fill colors. Please adjust it so that it has only one fill color.**
 *
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/download-assets.svg
 */
const IconDownloadAssets: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M21.343 6.24A2.145 2.145 0 0123.5 8.399v10.074a2.146 2.146 0 01-2.157 2.157H2.658A2.144 2.144 0 01.5 18.472V5.527a2.139 2.139 0 011.33-1.996c.263-.108.544-.162.828-.16h7.19l2.876 2.877 8.62-.007zm-.27 12.22a.318.318 0 00.27-.27V8.661a.317.317 0 00-.27-.27h-9.257L8.939 5.514H2.918a.317.317 0 00-.27.27V18.19a.317.317 0 00.27.27h18.155z"
      fill="currentColor"
    />
    <path
      d="M15.018 11.336h7.073v8.452H13.64v-7.074a1.378 1.378 0 011.379-1.378z"
      fill="currentColor"
    />
    <path
      d="M18.33 17.291a.509.509 0 00.364.15.5.5 0 00.364-.15l1.595-1.593a.51.51 0 10-.722-.722l-.714.714v-2.857a.516.516 0 10-1.029 0v2.857l-.716-.714a.512.512 0 00-.84.161.512.512 0 00.12.561l1.578 1.593z"
      fill="currentColor"
    />
    <path
      d="M20.752 16.958a.52.52 0 00-.514.522v.597h-3.07v-.604a.517.517 0 00-.317-.476.513.513 0 00-.562.116.518.518 0 00-.15.367v1.112a.516.516 0 00.514.517h4.099a.515.515 0 00.514-.517v-1.119a.517.517 0 00-.317-.476.514.514 0 00-.197-.039z"
      fill="currentColor"
    />
  </svg>
);

export default IconDownloadAssets;
